import { RiContactsBook3Line } from "react-icons/ri";
import { Grid2x2Plus, Users } from "lucide-react";
import {
  AssignmetnsIcon,
  CampaignsIcon,
  DashboardIcon,
  FormIcon,
  InterpreterIcon,
  OrganizationsIcon,
  VideoIcon,
} from "@/assets/svgs/icons";

export const ADMIN_MENU_SECTIONS = [
  {
    key: "overview",
    items: [
      {
        key: "/admin/dashboard",
        label: "Dashboard",
        icon: <DashboardIcon />,
      },
      {
        key: "/admin/enquiries",
        label: "Enquiries",
        icon: (
          <RiContactsBook3Line className="text-2xl" style={{ fontSize: 24 }} />
        ),
      },
    ],
  },
  {
    key: "workspace",
    items: [
      {
        key: "/admin/organisations",
        label: "Organisations",
        icon: <OrganizationsIcon />,
      },
      {
        key: "/admin/forms",
        label: "Forms",
        icon: <FormIcon />,
      },
      {
        key: "/admin/campaigns",
        label: "Campaigns",
        icon: <CampaignsIcon />,
      },
      {
        key: "/admin/panel-user",
        label: "Panel user",
        icon: <Users size={24} />,
      },
      {
        key: "/admin/interpreter",
        label: "Interpreters",
        icon: <InterpreterIcon />,
      }
    ],
  },
  {
    key: "more",
    items: [
      {
        key: "/admin/video-catalog",
        label: "Video Catalogue",
        icon: <VideoIcon />,
      },
      {
        key: "/admin/templates",
        label: "Templates",
        icon: <Grid2x2Plus />,
      },
    ],
  },
];

export const ADMIN_MENU_ITEMS = ADMIN_MENU_SECTIONS.flatMap(
  (section) => section.items,
);

export const ORGANIZATION_MENU_ITEMS = [
  {
    key: "/organisation/dashboard",
    label: "Dashboard",
    icon: <DashboardIcon />,
  },
  {
    key: "/organisation/campaigns",
    label: "Campaigns",
    icon: <CampaignsIcon />,
  },
  {
    key: "/organisation/forms",
    label: "Forms",
    icon: <FormIcon />,
  },
];

export const INTERPRETER_MENU_ITEMS = [
  {
    key: "/interpreter/dashboard",
    label: "Dashboard",
    icon: <DashboardIcon />,
  },
  {
    key: "/interpreter/assignments",
    label: "Assignments",
    icon: <AssignmetnsIcon />,
  },
];
